import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPublicJobList } from "./publicJobListAPI";

const initialState = {
  data: [],
  total: 0,
  loading: false,
  error: null,
  currentFilters: {},
};

export const fetchPublicJobListAsync = createAsyncThunk(
  "JobList/fetch",
  async (filters = {}, { rejectWithValue }) => {
    try {
      // If filters is just a number (page), convert it to an object for backward compatibility
      const filterParams = typeof filters === 'number' ? { page: filters } : filters;

      const data = await fetchPublicJobList(filterParams);
      const resp = data?.response;

      if (!resp || !resp.data) {
        throw new Error("Invalid response structure");
      }

      return {
        jobs: resp.data,
        totalJobs: resp.total,
        filters: filterParams,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublicJobListSlice = createSlice({
  name: "PublicJobList",
  initialState,
  reducers: {
    clearFilters: (state) => {
      state.currentFilters = {};
      state.error = null;
    },
    updateFilters: (state, action) => {
      state.currentFilters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicJobListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicJobListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.currentFilters = action.payload.filters;
        state.error = null;
      })
      .addCase(fetchPublicJobListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearFilters, updateFilters } = PublicJobListSlice.actions;

export const selectPublicJobList = (state) => state.publicJobList.data.jobs;
export const selectPublicJobListTotal = (state) => state.publicJobList.data.totalJobs;
export const selectCurrentFilters = (state) => state.publicJobList.currentFilters;

export default PublicJobListSlice.reducer;
